export default {
  F01_01_BCQT: '01_01_BCQT',
};
